/**
 * Textos de les millores de Compres (`en`): ajunta els fitxers de cada tall. Cablejat a `en.ts` amb un sol
 * `...compresEn`; així cada tall edita només el seu fitxer.
 */

import { estatsEn } from './estats.en.js';
import { filtresEn } from './filtres.en.js';
import { devolucionsEn } from './devolucions.en.js';

export const compresEn = {
  ...estatsEn,
  ...filtresEn,
  ...devolucionsEn,
} as const;
